"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createSvgIcon_1 = __importDefault(require("../createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("path", { d: "M12.1195 8.00006C12.1195 6.42691 11.2104 5.06767 9.89126 4.41256V11.592C11.2104 10.9325 12.1195 9.57322 12.1195 8.00006ZM0.0869141 5.32615V10.674H3.65213L8.10865 15.1305V0.869629L3.65213 5.32615H0.0869141Z" }), 'VolumeMedium');
//# sourceMappingURL=index.js.map